import request from '@/utils/request';

// 供应商_退货地址
export const getProviderReturnLogistics = (data: any): any =>
  request({
    url: '/provider/return/logistics',
    data: data
  })
// 供应商_退货地址-无分页
export const providerReturnAddressSelectItem = (data: any): any =>
  request({
    url: '/pc/product/providerReturnAddressSelectItem',
    data: data
  })

// 物流公司
export const getExpressList = (data: any): any =>
  request({
    url: '/api/express/list',
    data: data
  })

// 物流模版列表
export const logisticsTplList = (data: any): any =>
  request({
    url: '/pc/freightTemplate/list',
    data
  })

// 供应商模板列表
export const providerLogisticsTplList = (data: any): any =>
  request({
    url: '/pc/freightTemplate/Providerlist',
    data
  })

// 供应商模板列表
export const productfreightTemplateSelectitem = (data: any): any =>
  request({
    url: '/pc/product/freightTemplateSelectitem',
    data
  })

// 物流模版操作
export const doLogisticsTpl = (data: any) =>
  request({
    url: '/pc/freightTemplate/delete',
    data
  })


// 物流模版详情
export const freightTemplateInfo = (data: any) =>
  request({
    url: '/pc/freightTemplate/info',
    data
  })

// 物流模版详情-保存
export const freightTemplateSave = (data: any) =>
request({
  url: '/pc/freightTemplate/save',
  data
})